import ProductData from '../../../../services/product/product-data'
import ProductStockService from '../../../../services/stock'

const isMock = false

export const fetchProductData = async (
  config: {
    cbxUrl: string
    market: string
    locale: string
    channel: string
  },
  key: string
) =>
  ProductData.getProductData(
    config?.cbxUrl,
    key,
    config?.market,
    config?.locale,
    config?.channel,
    isMock
  )

export const fetchStockData = async (
  config: {
    cbxUrl: string
    market: string
    channel: string
  },
  articleList: string[]
) =>
  ProductStockService.getProductsStockData({
    cbxUrl: config?.cbxUrl,
    market: config?.market,
    channel: config?.channel,
    articleList,
    isMock
  })
